(() => {
  const LEGEND_TEXT = 'Inhoud';
  const SELECT_ID   = 'multivariants_0_block_select_0';
  const TARGET_ID   = 'custom-multivariant-field';

  const ready = (fn) =>
    document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn);

  const slugify = (s) =>
    String(s).trim().toLowerCase()
      .replace(/[\s_]+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

  function buildRadiosFromSelect(sel) {
    if (!sel) return;

    const fs = document.createElement('fieldset');
    fs.className = 'option-selector';
    fs.dataset.selectorType = 'listed';
    fs.innerHTML = `
      <legend class="label">${LEGEND_TEXT}</legend>
      <div class="option-selector__btns flex flex-wrap"></div>
    `;
    const wrap = fs.querySelector('.option-selector__btns');

    [...sel.options].forEach((opt) => {
      const id = `custom-${slugify(opt.textContent)}`;

      const input = Object.assign(document.createElement('input'), {
        type: 'radio',
        id,
        name: 'custom-multivariants',
        value: opt.value,
        className: 'opt-btn visually-hidden focus-label',
        checked: opt.selected
      });

      input.addEventListener('change', (e) => {
        sel.value = e.target.value;
        if (typeof window.selectMultiVariantsOption === 'function') {
          window.selectMultiVariantsOption(sel.value);
        } else {
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      const label = document.createElement('label');
      label.className = 'opt-label opt-label--btn btn relative text-center';
      label.htmlFor = id;
      label.innerHTML = `<span>${opt.textContent}</span>`;

      wrap.append(input, label);
    });

    const mount = document.getElementById(TARGET_ID) || sel.parentElement;
    mount.innerHTML = '';
    mount.appendChild(fs);

    sel.style.display = 'none';

    sel.addEventListener('change', () => {
      const r = fs.querySelector(`input[value="${sel.value}"]`);
      if (r) r.checked = true;
    });
  }

  ready(() => {
    const ensure = () => {
      const sel = document.getElementById(SELECT_ID);
      if (sel && !sel.dataset.customized) {
        sel.dataset.customized = '1';
        buildRadiosFromSelect(sel);
        return true;
      }
      return false;
    };

    if (!ensure()) {
      const obs = new MutationObserver(() => { if (ensure()) obs.disconnect(); });
      obs.observe(document.body, { childList: true, subtree: true });
    }
  });
})();